module.exports = __webpack_public_path__ + "img/product-card-hero-md.65bc0b7.webp";